import { cn, Link } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import useTranslation from '@Queries/useTranslation';
import { useRequest } from '@Contexts/Request';
import styles from './Footnote.module.css';

import type { FC, HTMLAttributes } from 'react';

type FootnoteProps = HTMLAttributes<HTMLDivElement>;

const Footnote: FC<FootnoteProps> = (props) => {
  const { className, ...restProps } = props;
  const { t } = useTranslation();
  const { country } = useRequest();

  const handleClickRules = () => {
    const hash = country === 'KAZ' ? '#mebel-club-rules' : '#divan-club-rules';

    ModalWindows.open('StaticInfo', { slug: 'divan-club-rules', hash });
  };

  return (
    <div className={cn(styles.footnote, className)} {...restProps}>
      {t('footnote.1')}{' '}
      <Link view='native' onClick={handleClickRules}>
        {t('footnote.2')}
      </Link>{' '}
      {t('footnote.3')}{' '}
      <Link view='native' to='/static-page/privacy-policy' target='_blank'>
        {t('footnote.4')}
      </Link>
    </div>
  );
};

export default Footnote;
